import { jsonCopy } from '../../../utility/genericUtility';
import { datiStampaProposalInizializzato, datiInvioEmailInizializzato } from '../componentiBase/sezioniStampaProposal';
    
export const datiStampaProposal = jsonCopy(datiStampaProposalInizializzato);
export const datiInvioEmail = jsonCopy(datiInvioEmailInizializzato);

